export { WhySgHero } from './WhySgHero';
